// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "assets/js/" + chunkId + ".js"; };